import { render, staticRenderFns } from "./RefreshButton.vue?vue&type=template&id=715afada&scoped=true"
import script from "./RefreshButton.vue?vue&type=script&lang=js"
export * from "./RefreshButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715afada",
  null
  
)

export default component.exports